import { render, staticRenderFns } from "./batch-form-pm-ck.vue?vue&type=template&id=474bc1df&scoped=true&"
import script from "./batch-form-pm-ck.vue?vue&type=script&lang=js&"
export * from "./batch-form-pm-ck.vue?vue&type=script&lang=js&"
import style0 from "./batch-form-pm-ck.vue?vue&type=style&index=0&id=474bc1df&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474bc1df",
  null
  
)

component.options.__file = "batch-form-pm-ck.vue"
export default component.exports